import { useState, useEffect } from "react";
import { Loader2, ListPlus, Library } from "lucide-react";
import { PokemonCardTile } from "./PokemonCardTile";
import { makeVariant } from "../lib/variants";
import { fetchListCards } from "../lib/api";

// Contenu d'une liste PARTAGÉE par un ami (cf. section "Listes partagées"
// de FriendCollectionView). Volontairement pas de bouton retirer/quantité —
// c'est SA liste, pas la tienne. Les tuiles utilisent TA PROPRE collection
// (pas la sienne) : le but est de voir d'un coup d'œil ce que tu as déjà
// parmi ce qu'il recherche, et de cliquer une carte t'ouvre TA fiche normale
// (tu peux directement la marquer possédée/recherchée depuis là).
export const FriendListView = ({
  listId, friendId, collection, conditions = {}, onCardClick, onStatusChange, onRemove,
}) => {
  const [cards, setCards] = useState([]);
  const [listName, setListName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchListCards(listId, friendId)
      .then(data => {
        if (cancelled) return;
        setCards(data.cards || []);
        setListName(data.list?.name || "");
      })
      .catch(err => console.error("Liste d'ami :", err))
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [listId, friendId]);

  if (loading) {
    return <div className="flex justify-center py-20"><Loader2 className="w-10 h-10 animate-spin text-red-500" /></div>;
  }

  // Bascule owned/wanted sur TA propre collection (même logique que les
  // autres vues) : cliquer un badge marque/démarque cette carte pour toi.
  const handleVariantClick = (cardId, variantType, currentStatus, shiftKey) => {
    if (shiftKey) {
      if (currentStatus === "wanted") onRemove(cardId, variantType);
      else onStatusChange(cardId, variantType, "wanted");
    } else {
      if (!currentStatus || currentStatus === "wanted") onStatusChange(cardId, variantType, "owned");
      else onRemove(cardId, variantType);
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold text-white mb-1 flex items-center gap-2">
        <ListPlus className="w-6 h-6 text-red-500" />{listName}
        <span className="text-base font-normal text-zinc-500">({cards.length})</span>
      </h2>
      <p className="text-sm text-zinc-500 mb-6">Les couleurs reflètent TA collection, pas la sienne.</p>

      {cards.length === 0 ? (
        <div className="text-center py-16 text-zinc-500">
          <Library className="w-12 h-12 mx-auto mb-4 opacity-50" />
          <p>Cette liste est vide.</p>
        </div>
      ) : (
        <div className="card-grid">
          {cards.map(card => (
            <PokemonCardTile
              key={`${card.id}::${card.list_variant}`}
              card={card}
              collectionMap={collection}
              conditionMap={conditions}
              onCardClick={onCardClick}
              onVariantClick={handleVariantClick}
              cardVariants={[makeVariant(card.list_variant)]}
            />
          ))}
        </div>
      )}
    </div>
  );
};
